/* eslint-disable @typescript-eslint/no-use-before-define */
import { Close } from "@mui/icons-material";
import { Stack, IconButton, useTheme, useMediaQuery, Box } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

export interface FormDialogProps {
  title: string;
  isOpen: boolean;
  close: () => void;
  image: any;
}

const ImageFormDialog = (props: FormDialogProps) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <Dialog
      open={props.isOpen}
      fullScreen={fullScreen}
      fullWidth
      aria-labelledby="alert-dialog-title"
    >
      <DialogTitle id="alert-dialog-title">
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          {props.title}
          <IconButton onClick={props.close} color="error">
            <Close />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Box component="img" src={props.image} alt={props.title} width="100%" />
      </DialogContent>
    </Dialog>
  );
};

export default ImageFormDialog;
